import { useState, useEffect } from "react";
import {
  Container,
  Grid,
  Table,
  Center,
  Loader,
  Group,
  Pagination,
  Select,
  ActionIcon,
  Text,
} from "@mantine/core";
import { useLocation } from "wouter";
import { getAdminJobs } from "../api";
import JobStatusBadge from "./JobStatusBadge";
import { IconRefresh } from "@tabler/icons-react";

const formatJobType = (type) =>
  type?.replace(/Job$/, "").replace(/([A-Z])/g, " $1").trim() || type;

const formatTimestamp = (ts) => {
  if (!ts) return "—";
  const d = new Date(ts);
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) +
    " " + d.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" });
};

const truncateId = (id) => id?.slice(0, 8) + "…" || "—";

export default function JobList() {
  const [, setLocation] = useLocation();
  const [jobs, setJobs] = useState(null);
  const [tenantFilter, setTenantFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [forceRefresh, setForceRefresh] = useState(0);
  const pageSize = 20;

  useEffect(() => {
    setIsLoading(true);
    getAdminJobs(
      activePage,
      pageSize,
      tenantFilter ?? "",
      statusFilter ?? ""
    ).then((data) => {
      setJobs(data);
      setIsLoading(false);
    });
  }, [activePage, statusFilter, tenantFilter, forceRefresh]);

  if (!jobs)
    return (
      <Center mt="xl">
        <Loader size="xl" />
      </Center>
    );

  return (
    <Container size="xl">
      <Grid justify="space-between" gap="2px">
        <Grid.Col span={12}>
          <Group>
            <Pagination
              hideWithOnePage={false}
              total={Math.max(1, Math.ceil(jobs.totalCount / pageSize))}
              value={activePage}
              onChange={setActivePage}
            />
            {isLoading ? (
              <Loader size="sm" />
            ) : (
              <ActionIcon onClick={() => setForceRefresh(forceRefresh + 1)}>
                <IconRefresh size={16} />
              </ActionIcon>
            )}

            <Select
              clearable
              value={statusFilter}
              onChange={setStatusFilter}
              data={["success", "processing", "queued", "failed"]}
            />
          </Group>
          {/* {isLoading && (
            <Center>
              <Loader />
            </Center>
          )} */}

          {/* {jobs.data.map((p) => (
            <Paper>
              <Code block>{JSON.stringify(p, null, 2)}</Code>
            </Paper>
          ))} */}

          <Table stickyHeader stickyHeaderOffset={60}>
            <Table.Thead>
              <Table.Tr>
                <Table.Th>Type</Table.Th>
                <Table.Th>Status</Table.Th>
                <Table.Th>Started</Table.Th>
                <Table.Th>NextRun</Table.Th>
                <Table.Th>RetryCount</Table.Th>
                <Table.Th>Tenant</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {jobs.data.map((p) => (
                <Table.Tr
                  style={{ cursor: "pointer" }}
                  onClick={() => setLocation(`jobs/${p.job.id}`)}
                  key={p.job.id}
                >
                  <Table.Td>{formatJobType(p.type)}</Table.Td>
                  <Table.Td>
                    <JobStatusBadge status={p.job.status} />
                  </Table.Td>
                  <Table.Td>{formatTimestamp(p.job.started)}</Table.Td>
                  <Table.Td>{formatTimestamp(p.job.nextRun)}</Table.Td>
                  <Table.Td>{p.job.retryCount}</Table.Td>
                  <Table.Td>
                    <Text size="xs" c="dimmed" title={p.job.tenantId}>
                      {truncateId(p.job.tenantId)}
                    </Text>
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
        </Grid.Col>
      </Grid>
    </Container>
  );
}
